import logo from "logo.svg";

export const LogoPage = () => {
  return (
    <div className="fixed top-0 left-0 flex w-full h-screen justify-center items-center pointer-events-none">
      <img src={logo} className="App-logo h-80" alt="logo" />
    </div>
  );
}
